<div class="relative" [class.pl-4]="showSearchIcon" [formGroup]="form">
  <img
    *ngIf="showSearchIcon"
    src="/assets/v4/icon-search.svg"
    alt=""
    class="w-16[px] h-[16px] absolute left-0 top-1/2 -translate-y-1/2 z-10"
  />
  <input class="pr-5" type="text" [nzSize]="size" nz-input formControlName="value" [placeholder]="placeholder" />
  <i
    nz-icon
    class="absolute top-1/2 right-2 -translate-y-1/2 text-xs cursor-pointer"
    nzType="close-circle"
    *ngIf="value"
    (click)="form.reset()"
  ></i>
</div>
